import { ReactComponent as EmptyPanelDroneIcon } from '@assets/components/panel/notification/empty-panel-drone-icon.svg';
import { Text, VStack } from '@chakra-ui/react';
import LiveNotificationList from '@components/cockpit/panels/notification/LiveNotificationList';
import { DraggablePanel } from '@components/ui/draggable';
import { useAppSelector } from '@hooks/redux.hooks';
import { useStableIds } from '@hooks/useStableIds';
import { selectAllOngoingDroneNotifications } from '@redux/data/data.selectors';
import { FormattedMessage } from 'react-intl';

import { PopupPositionData } from '@/types/popup.types';

export default function OngoingDroneNotificationsPopup({
  mapConstraintsRef,
  top,
  left,
  onClose,
}: Readonly<PopupPositionData>) {
  const notifications = useAppSelector(selectAllOngoingDroneNotifications);
  const notificationIds = useStableIds(notifications.map((notification) => notification.id));

  return (
    <DraggablePanel.Root constraintsRef={mapConstraintsRef} top={top} left={left}>
      <DraggablePanel.Header onClose={onClose}>
        <FormattedMessage id="controls.toolMenu.ongoingDroneNotifications" />
      </DraggablePanel.Header>
      <DraggablePanel.Body height={730} width="1040px">
        {notificationIds.length === 0 ? (
          <VStack gap={3} marginY="auto">
            <EmptyPanelDroneIcon />
            <Text textStyle="screenStd" fontWeight="medium" color="neutral.200" textAlign="center" userSelect="none">
              <FormattedMessage id="components.notification.empty" />
            </Text>
          </VStack>
        ) : (
          <LiveNotificationList notificationIds={notificationIds} hideProcedure />
        )}
      </DraggablePanel.Body>
    </DraggablePanel.Root>
  );
}
